module.exports = __webpack_public_path__ + "img/cl_export_doc_2.a8a47854.png";